import { render, staticRenderFns } from "./TambahShift.vue?vue&type=template&id=3acb9400&scoped=true"
import script from "./TambahShift.vue?vue&type=script&lang=js"
export * from "./TambahShift.vue?vue&type=script&lang=js"
import style0 from "./TambahShift.vue?vue&type=style&index=0&id=3acb9400&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3acb9400",
  null
  
)

export default component.exports